import type { SiteTextFallbackMap } from "./defaultSiteTextFallbacksTypes";

/** Office + third-party fallback entries (max-lines split). */
export const SITE_TEXT_FALLBACKS_FR_TAIL: SiteTextFallbackMap = {
	"office.header.active": ["office", "Office active"],
	"office.labels.address": ["office", "Adresse"],
	"office.labels.crpcen": ["office", "CRPCEN"],
	"office.labels.denomination": ["office", "Dénomination"],
	"office.titles.administrators": ["office", "Administrateurs"],
	"office.titles.collaborators": ["office", "Collaborateurs"],
	"office.userLabels.email": ["office", "E-mail"],
	"office.userLabels.firstName": ["office", "Prénom"],
	"office.userLabels.lastName": ["office", "Nom"],
	"office.userLabels.phone": ["office", "Téléphone"],
	"office.userLabels.role": ["office", "Rôle"],
	"office.userRestrictedFallback": ["office", "Utilisateur restreint"],
	"thirdParty.roleLabel.agentImmobilier": ["thirdParty", "Agent Immobilier"],
	"thirdParty.roleLabel.avocat": ["thirdParty", "Avocat"],
	"thirdParty.roleLabel.autre": ["thirdParty", "Autre"],
	"thirdParty.roleLabel.banque": ["thirdParty", "Banque"],
	"thirdParty.roleLabel.courtier": ["thirdParty", "Courtier"],
	"thirdParty.roleLabel.expert": ["thirdParty", "Expert"],
	"thirdParty.roleLabel.genealogiste": ["thirdParty", "Généalogiste"],
	"thirdParty.roleLabel.syndic": ["thirdParty", "Syndic"],
	"thirdParty.roleLabel.tutelle": ["thirdParty", "Tutelle"],
};
